import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { PageHeader, PageBody, Section } from "../components/layout/Page";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function ChangePassword() {
  const [oldPwd, setOldPwd] = useState("");
  const [newPwd, setNewPwd] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/change-password", { old_password: oldPwd, new_password: newPwd });
      toast.success("Password updated successfully");
      nav("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to update password");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div data-testid="change-password-page">
      <PageHeader eyebrow="Account" title="Change password" subtitle="Update your sign-in credentials." />
      <PageBody>
        <div className="max-w-md">
          <Section title="New password">
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label className="text-[10px] uppercase tracking-[0.18em] font-semibold text-[#475569]">Current password</Label>
                <Input type="password" value={oldPwd} onChange={(e) => setOldPwd(e.target.value)} required className="mt-1 rounded-sm" data-testid="old-password" />
              </div>
              <div>
                <Label className="text-[10px] uppercase tracking-[0.18em] font-semibold text-[#475569]">New password</Label>
                <Input type="password" value={newPwd} onChange={(e) => setNewPwd(e.target.value)} required minLength={6} className="mt-1 rounded-sm" data-testid="new-password" />
              </div>
              <Button type="submit" disabled={loading} className="rounded-sm bg-[#2563EB] hover:bg-[#1D4ED8] text-xs uppercase tracking-wider" data-testid="change-password-submit">
                Update password
              </Button>
            </form>
          </Section>
        </div>
      </PageBody>
    </div>
  );
}
